export class ValidationStudentApiError extends Error {
	constructor(public errors: object) {
		super('Validation exception occurred while contacting the student api');
		this.name = 'ValidationStudentApiError';
	}
}
